<template>
  <div
    class="text-left"
    :data-qa="`setting-card-${loading ? 'loading' : value.settingOrganizationId}-setting-value`">
    <template v-if="loading">
      -
    </template>
    <template v-else-if="value && value.settingInfo && value.settingInfo.settingType">
      <sSwitch
        v-if="value.settingInfo.settingType === settingTypes.boolean"
        :disabled="value.userCount !== 0"
        :true-value="'+'"
        :value="value.settingValue"
        @update:value="editOrganizerSetting"/>
      <ScrollShadow
        v-else
        class="height-100"
        style="max-height: 100px;">
        <SettingHtmlView
          v-if="value.settingInfo.settingType === settingTypes.html"
          :value="value.settingValue"/>
        <SettingEmailsView
          v-if="isList"
          :value="value.settingValue"/>
        <SettingFormioView
          v-else-if="isForm"
          :value="value.settingValue"/>
        <template v-else-if="value.settingInfo.settingType === settingTypes.timeSpan">
          <TimeSpan
            class="my-auto"
            :disabled="true"
            mode="text"
            :value="value.settingValue"/>
        </template>
        <template v-else>
          {{ value.settingValue }}
        </template>
      </ScrollShadow>
    </template>
  </div>
</template>
<script>
import TimeSpan from 'components/common/TimeSpan.vue'
import ScrollShadow from 'components/common/ScrollShadow.vue'
import SettingHtmlView from 'components/organizer-settings/SettingHtmlView.vue'
import SettingFormioView from 'components/organizer-settings/SettingFormioView.vue'
import SettingEmailsView from 'components/organizer-settings/SettingEmailsView.vue'

import organizerSettings from 'mixins/organizerSettings'

export default {
  name: 'SettingValueView',
  mixins: [organizerSettings],
  methods: {
    editOrganizerSetting() {
      if (this.value.userCount !== 0) {
        return
      }
      const newValue = this.value.settingValue === '-' ? '+' : '-'
      this.$emit('changeValue', {
        settingOrganizationId: this.value.settingOrganizationId,
        newValue: newValue
      })
    }
  },
  computed: {
    isForm() {
      return this.value.settingInfo.settingType === this.settingTypes.form/*|| this.value.settingInfo.settingType === this.settingTypes.formList*/
    },
    isList() {
      const listType = [this.settingTypes.emailList, this.settingTypes.multipleSelectList, this.settingTypes.inputList]
      return listType.includes(this.value.settingInfo.settingType)
    }
  },
  components: {
    TimeSpan,
    ScrollShadow,
    SettingHtmlView,
    SettingFormioView,
    SettingEmailsView
  },
  props: {
    value: {
      type: [Object, String]
    },
    loading: {
      type: Boolean
    }
  },
}
</script>
